"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._execute_flingDisc = exports._execute_placeDisc = exports.execute = exports.forwardToAll = exports.requestHost = exports.create = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.ECrokinoleInputHint = void 0;
var crokinolePucks_sidecar_1 = require("@crokinole/entities/crokinolePucks-sidecar");
var crokinoleGameState_sidecar_1 = require("@crokinole/main/crokinoleGameState-sidecar");
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageWebsockets_1 = require("@voyage/multi-sockets/voyageWebsockets");
var voyageMessageIds_1 = require("@voyage/multi/voyageMessageIds");
var namespace = 'crokinoleMessage_input';
var ECrokinoleInputHint;
(function (ECrokinoleInputHint) {
    ECrokinoleInputHint[ECrokinoleInputHint["Null"] = 0] = "Null";
    ECrokinoleInputHint[ECrokinoleInputHint["PlaceDisc"] = 1] = "PlaceDisc";
    ECrokinoleInputHint[ECrokinoleInputHint["FlingDisc"] = 2] = "FlingDisc";
    ECrokinoleInputHint[ECrokinoleInputHint["StartGame"] = 3] = "StartGame";
    ECrokinoleInputHint[ECrokinoleInputHint["ResetGame"] = 4] = "ResetGame";
    ECrokinoleInputHint[ECrokinoleInputHint["GoToLobby"] = 5] = "GoToLobby";
    ECrokinoleInputHint[ECrokinoleInputHint["ChangeSettings"] = 6] = "ChangeSettings";
})(ECrokinoleInputHint = exports.ECrokinoleInputHint || (exports.ECrokinoleInputHint = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Crokinole_Input;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.hint);
    messageWriter_sidecar_1.messageWriter.write32(m, d.frame);
    messageWriter_sidecar_1.messageWriter.write32(m, d.targetId);
    if (d.hint === ECrokinoleInputHint.FlingDisc ||
        d.hint === ECrokinoleInputHint.PlaceDisc) {
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.wx);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.wy);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.fx);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.fy);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.angle);
    }
    if (d.hint === ECrokinoleInputHint.PlaceDisc) {
        messageWriter_sidecar_1.messageWriter.write32(m, d.playerNum);
    }
    if (d.hint === ECrokinoleInputHint.ChangeSettings) {
        messageWriter_sidecar_1.messageWriter.writeString(m, d.settingName);
        messageWriter_sidecar_1.messageWriter.writeString(m, d.settingValue);
    }
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        hint: messageWriter_sidecar_1.messageWriter.read8(m),
        frame: messageWriter_sidecar_1.messageWriter.read32(m),
        targetId: messageWriter_sidecar_1.messageWriter.read32(m),
        wx: 0,
        wy: 0,
        fx: 0,
        fy: 0,
        angle: 0,
        playerNum: 0,
        settingName: '',
        settingValue: '',
    };
    if (d.hint === ECrokinoleInputHint.FlingDisc ||
        d.hint === ECrokinoleInputHint.PlaceDisc) {
        d.wx = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.wy = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.fx = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.fy = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.angle = messageWriter_sidecar_1.messageWriter.readFloat(m);
    }
    if (d.hint === ECrokinoleInputHint.PlaceDisc) {
        d.playerNum = messageWriter_sidecar_1.messageWriter.read32(m);
    }
    if (d.hint === ECrokinoleInputHint.ChangeSettings) {
        d.settingName = messageWriter_sidecar_1.messageWriter.readString(m);
        d.settingValue = messageWriter_sidecar_1.messageWriter.readString(m);
    }
    return d;
}
exports.read = read;
function test() {
    var ex = create({
        hint: ECrokinoleInputHint.GoToLobby,
        frame: 120,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput 1', ex, write, read);
    ex = create({
        hint: ECrokinoleInputHint.FlingDisc,
        frame: 121,
        wx: 123.45,
        //wy: 456.78,
        wy: 456789.456789,
        fx: 999.999,
        fy: 888.888,
        //wy: 12323423.2342342,
        angle: -45.556,
        targetId: 123,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput FlingDisc', ex, write, read);
    ex = create({
        hint: ECrokinoleInputHint.ChangeSettings,
        frame: 122,
        settingName: 'asdf',
        settingValue: '123',
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput ChangeSettings', ex, write, read);
    ex = create({
        hint: ECrokinoleInputHint.PlaceDisc,
        frame: 121,
        wx: 123.45,
        wy: 456.78,
        angle: -45.556,
        targetId: 123,
        playerNum: 2,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput PlaceDisc', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msg = read(m);
    console.log(namespace, 'process', msg.hint, msg.frame);
    if (msg.frame <= 0) {
        // Requesting to calculate frame
        if (voyageWebsockets_1.getIsHost()) {
            // TODO: any more validation of message?
            // TODO: better way to do this?
            if (crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.isPlayerOnCorrectGameSync(fromId)) {
                var updatedMsg = Object.assign({}, msg, {
                    frame: crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().nextMessageSimulationFrame,
                });
                // console.log('mouseInput', 'updating msg', updatedMsg)
                forwardToAll(updatedMsg);
            }
            else {
                console.error(namespace, 'rejecting message, out of sync');
            }
        }
        else {
            console.error(namespace, 'rejecting message, not host');
        }
    }
    else {
        // Add to our frame stack
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.addMessageToBuffer(msg);
    }
}
exports.process = process;
function create(msg) {
    var _default = {
        hint: ECrokinoleInputHint.Null,
        targetId: 0,
        frame: 0,
        playerNum: 0,
        wx: 0,
        wy: 0,
        fx: 0,
        fy: 0,
        angle: 0,
        settingName: '',
        settingValue: '',
    };
    var combinedMsg = Object.assign({}, _default, msg);
    return combinedMsg;
}
exports.create = create;
function requestHost(msg) {
    console.log(namespace, 'requestHost', msg.hint, msg.frame);
    var combinedMsg = create(msg);
    websockets_sidecar_1.websockets._sendMessageToHost(write, combinedMsg, true);
}
exports.requestHost = requestHost;
function forwardToAll(msg) {
    console.log(namespace, 'forwardToAll', msg.hint, msg.frame);
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.forwardToAll = forwardToAll;
function execute(msg) {
    console.log(namespace, 'execute', msg.hint);
    if (msg.hint === ECrokinoleInputHint.PlaceDisc) {
        _execute_placeDisc(msg);
        return;
    }
    if (msg.hint === ECrokinoleInputHint.FlingDisc) {
        _execute_flingDisc(msg);
        return;
    }
}
exports.execute = execute;
function _execute_placeDisc(msg) {
    var player = crokinoleGameState_sidecar_1.crokinoleGameState.getPlayer(msg.playerNum);
    if (player.numTokensLeft >= 0) {
        // TODO: more checks for valid state?
        player.numTokensLeft--;
        var newPuck = crokinolePucks_sidecar_1.crokinolePucks.create(msg.wx, msg.wy, player);
        crokinoleGameState_sidecar_1.crokinoleGameState.get().currentPuck = newPuck;
        crokinoleGameState_sidecar_1.crokinoleGameState.advanceState();
    }
}
exports._execute_placeDisc = _execute_placeDisc;
function _execute_flingDisc(msg) {
    var currentPuck = crokinolePucks_sidecar_1.crokinolePucks.getById(msg.targetId);
    if (!currentPuck) {
        assert_sidecar_1.assert.warn('puck not found', msg.targetId);
        return;
    }
    currentPuck.rigidBody.applyImpulseAtPoint({
        x: msg.fx,
        y: msg.fy,
    }, {
        x: msg.wx,
        y: msg.wy,
    }, true);
    // puck1.applyTorqueImpulse(0.01, true)
    console.log('flicked', 'advanceState', crokinoleGameState_sidecar_1.crokinoleGameState.get().state);
    crokinoleGameState_sidecar_1.crokinoleGameState.advanceState();
    console.log('flicked', 'advanceState2', crokinoleGameState_sidecar_1.crokinoleGameState.get().state);
}
exports._execute_flingDisc = _execute_flingDisc;
